export const MESSAGES = {
    SESSION_EXPIRED: "Session has expired" ,
    SERVER_ERROR : "Something went wrong while processing your request",
    "unknown" : "Something is went wrong" ,
    NEW_DATA_ADDED : "Added succesfully" ,
    UPDATED : `updated successfully` ,
    ASSIGNED : `Technician Assigned successfully` ,
    PAGE404 :`Error 404: Oops! The page you are looking for cannot be found`
}